export const MEDIA_VENDOR_REQUESTS_STORAGE_KEY = 'vendor_media_requests';

export const defaultMediaRequests = [
  {
    id: 'vendor-media-request-1',
    producerName: 'Sarvam Maya Productions',
    campaignName: 'Launch Week Digital Push',
    placementTitle: 'Regional Entertainment News Coverage',
    location: 'Kochi, Kerala',
    mediaType: 'Digital Media Publication',
    placement: 'Homepage feature and entertainment vertical story',
    requestedDuration: '5 days',
    startDate: '2026-04-09',
    budget: 65000,
    artwork: 'Launch-Week-PR-Brief.pdf',
    notes: 'Need feature placement tied to launch video and launch-window ticketing spike.',
    status: 'pending',
    requestedAt: '2026-04-04T10:10:00.000Z',
  },
  {
    id: 'vendor-media-request-2',
    producerName: 'Cobalt Frames',
    campaignName: 'Music Launch Amplification',
    placementTitle: 'Entertainment Portal Spotlight',
    location: 'Chennai, Tamil Nadu',
    mediaType: 'Digital Media Publication',
    placement: 'Music release article with homepage carousel placement',
    requestedDuration: '3 days',
    startDate: '2026-04-12',
    budget: 48000,
    artwork: 'Music-Launch-Coverage-Deck.pptx',
    notes: 'Priority is music section placement with social amplification hooks.',
    status: 'pending',
    requestedAt: '2026-04-04T12:00:00.000Z',
  },
  {
    id: 'vendor-media-request-3',
    producerName: 'Lightbox Studios',
    campaignName: 'Audience Recall Drive',
    placementTitle: 'Top Banner Entertainment Feature',
    location: 'Hyderabad, Telangana',
    mediaType: 'Digital Media Publication',
    placement: 'Homepage masthead banner plus feature article',
    requestedDuration: '7 days',
    startDate: '2026-03-17',
    budget: 92000,
    artwork: 'Audience-Recall-Media-Kit.zip',
    notes: 'Campaign delivered with full banner takeover and article support.',
    status: 'completed',
    requestedAt: '2026-03-01T08:45:00.000Z',
    reviewedAt: '2026-03-01T13:00:00.000Z',
    paymentReceivedAt: '2026-03-05T16:40:00.000Z',
  },
  {
    id: 'vendor-media-request-4',
    producerName: 'North Star Pictures',
    campaignName: 'Family Audience Digital Coverage',
    placementTitle: 'Weekend Family Feature Story',
    location: 'Kozhikode, Kerala',
    mediaType: 'Digital Media Publication',
    placement: 'Weekend feature story with newsletter inclusion',
    requestedDuration: '4 days',
    startDate: '2026-03-22',
    budget: 36000,
    artwork: 'Family-Audience-Coverage-Brief.pdf',
    notes: 'Payment received after successful family audience content rollout.',
    status: 'completed',
    requestedAt: '2026-03-09T09:15:00.000Z',
    reviewedAt: '2026-03-09T11:30:00.000Z',
    paymentReceivedAt: '2026-03-13T10:10:00.000Z',
  },
];
